import { render, staticRenderFns } from "./loading-list.vue?vue&type=template&id=0844fd2c"
import script from "./loading-list.vue?vue&type=script&lang=js"
export * from "./loading-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0844fd2c')) {
      api.createRecord('0844fd2c', component.options)
    } else {
      api.reload('0844fd2c', component.options)
    }
    module.hot.accept("./loading-list.vue?vue&type=template&id=0844fd2c", function () {
      api.rerender('0844fd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/loading-list.vue"
export default component.exports